import { Map } from 'immutable';
import { mapKeys as _mapKeys } from 'lodash';
import { records as deviceRecords } from '@saucelabs/sl-module-devices-rdc';

import * as constants from './../constants';
import { AppVersionRecord } from './../records';

const {
  MOBILE_DEVICE_STATES,
  MOBILE_SESSION_STATES,
} = constants;

const initialState = new Map({
  appVersion: null,
  appVersions: [],
  // FIXME we may want to come up with a proper naming convention -
  // in other places we call the `deviceDescriptor` simply `device`
  // here `device` is the connected device the session client provides (gs)
  device: null,
  deviceDescriptor: null,
  deviceOrientation: null,
  deviceAnimationsEnabled: false,
  deviceTakeScreenshotEnabled: true,
  deviceToolsEnabled: false,
  deviceWifiEnabled: true,
  // santa clara data center
  gpsLocation: {
    latitude: 37.3894698,
    longitude: -121.9643038,
    zoom: 9,
  },
  languages: {
    loading: true,
    items: {},
  },
  sessionPlatform: constants.FORM_TAB_STATES.PLATFORM_TYPE.WEB,
  sessionState: constants.MOBILE_SESSION_STATES.INITIAL,
  startedByTheUser: false,
});

function getSessionState(deviceState, state) {
  switch (deviceState) {
    case MOBILE_DEVICE_STATES.OFFLINE:
      return MOBILE_SESSION_STATES.DEVICE_DISCONNECTED;
    case MOBILE_DEVICE_STATES.LAUNCH:
    case MOBILE_DEVICE_STATES.VIDEO:
    case MOBILE_DEVICE_STATES.BOOTED:
    case MOBILE_DEVICE_STATES.INPUT:
      return MOBILE_SESSION_STATES.PREPARING;
    case MOBILE_DEVICE_STATES.ONLINE:
      if (state.get('startedByTheUser')) {
        return MOBILE_SESSION_STATES.PREPARING;
      }

      return MOBILE_SESSION_STATES.READY;
    default:
      return MOBILE_SESSION_STATES.INITIAL;
  }
}

function setDeviceToolsEnabled(state) {
  return state.set('deviceToolsEnabled', !!(state.get('device') && state.get('deviceDescriptor')));
}

const mobileSessionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.MOBILE_DEVICE_FETCH.SUCCESS:
      return setDeviceToolsEnabled(state.set('deviceDescriptor', new deviceRecords.DeviceDescriptor(payload)));
    case constants.MOBILE_DEVICE_FETCH.FAILURE:
      return setDeviceToolsEnabled(state.set('deviceDescriptor', initialState.get('deviceDescriptor')));
    case constants.MOBILE_SESSION_CREATE.REQUEST:
      return state.withMutations((mutable) => {
        mutable.set('sessionState', MOBILE_SESSION_STATES.REQUESTING);
        mutable.set('startedByTheUser', true);
      });
    case constants.MOBILE_SESSION_CREATE.SUCCESS:
      return state.set('sessionState', MOBILE_SESSION_STATES.ALLOCATING);
    case constants.MOBILE_SESSION_CREATE.FAILURE: {
      return state.set('sessionState', MOBILE_SESSION_STATES.SESSION_CREATION_FAILED);
    }
    case constants.MOBILE_DEVICE_CONNECT.SUCCESS:
      return setDeviceToolsEnabled(state.set('device', payload));
    case constants.MOBILE_DEVICE_CONNECT.FAILURE:
      return setDeviceToolsEnabled(state.set('device', initialState.get('device')).set('sessionState', MOBILE_SESSION_STATES.DEVICE_CONNECTION_FAILED));
    case constants.MOBILE_DEVICE_STATE_UPDATE:
      return state.set('sessionState', getSessionState(payload, state));
    case constants.MOBILE_DEVICE_APP_INSTALL.REQUEST:
      return state.set('sessionState', MOBILE_SESSION_STATES.INSTALLING);
    case constants.MOBILE_DEVICE_APP_INSTALL.SUCCESS:
    case constants.MOBILE_DEVICE_OPEN_URL.SUCCESS:
      return state.set('sessionState', MOBILE_SESSION_STATES.READY);
    case constants.MOBILE_DEVICE_APP_INSTALL.FAILURE: {
      // TODO handle error message (gs)
      console.log('App installation failed', payload);
      return state.set('sessionState', MOBILE_SESSION_STATES.APP_INSTALLATION_FAILED);
    }
    case constants.MOBILE_DEVICE_ANIMATIONS_TOGGLE.SUCCESS:
      return state.update('deviceAnimationsEnabled', (current) => !current);
    case constants.MOBILE_DEVICE_ROTATE.REQUEST:
    case constants.MOBILE_DEVICE_ROTATE.SUCCESS:
      return state.set('deviceOrientation', payload);
    case constants.MOBILE_DEVICE_TAKE_SCREENSHOT.REQUEST:
      return state.set('deviceTakeScreenshotEnabled', false);
    case constants.MOBILE_DEVICE_TAKE_SCREENSHOT.SUCCESS:
    case constants.MOBILE_DEVICE_TAKE_SCREENSHOT.FAILURE:
      return state.set('deviceTakeScreenshotEnabled', true);
    case constants.MOBILE_DEVICE_WIFI_TOGGLE.SUCCESS:
      return state.update('deviceWifiEnabled', (current) => !current);
    case constants.MOBILE_SESSION_APP_VERSION_FETCH.SUCCESS:
      return state.set('appVersion', new AppVersionRecord(payload));
    case constants.MOBILE_SESSION_APP_VERSION_FETCH.FAILURE:
      return state.set('appVersion', initialState.get('appVersion'));
    case constants.MOBILE_SESSION_APP_VERSIONS_FETCH.SUCCESS:
      return state.set('appVersions', payload.map((appVersion) => new AppVersionRecord(appVersion)));
    case constants.MOBILE_SESSION_APP_VERSIONS_FETCH.FAILURE:
      return state.set('appVersions', initialState.get('appVersions'));
    case constants.MOBILE_SESSION_STOP.SUCCESS:
      return initialState;
    case constants.MOBILE_DEVICE_LANGUAGES_FETCH.SUCCESS:
      return state.set('languages', {
        loading: false,
        items: _mapKeys(payload, 'id'),
      });
    case constants.MOBILE_DEVICE_GPS_LOCATION_CHANGE:
      return state.set('gpsLocation', payload);
    default:
      return state;
  }
};

export default mobileSessionReducer;
export { initialState };
